import { default as config } from "common/config/config";
import type { PaginatedReleaseStrategyDto } from "common/models/api/models/PaginatedReleaseStrategyDto";
import type { RoleDto } from "common/models/api/models/RoleDto";
import { useQuery, UseQueryOptions, UseQueryResult } from "react-query";
import useSelectedOrganizationAddress from "ui/role/hooks/useSelectedOrganizationAddress";
import { Queries } from "ui/query/queries";
import { releaseStrategyApi } from "../api/releaseStrategyApi";

export interface UseFindAllReleaseStrategyOptions {
    query?: string;
    address?: string;
    page?: number;
    pageSize?: number;
    order?: "ASC" | "DESC";
    orderBy?: string;
    organizationAddress?: string;
    selectedRole?: RoleDto;
    selectedOrganization?: string;
}

export default function useFindReleaseStrategies(
    {
        query,
        pageSize = config.paginatedPageSizes.programs,
        page,
        order,
        orderBy,
        organizationAddress: orgAddressParam,
    }: UseFindAllReleaseStrategyOptions,
    options?: UseQueryOptions<PaginatedReleaseStrategyDto, unknown, PaginatedReleaseStrategyDto, (string | undefined | number)[]>,
): UseQueryResult<PaginatedReleaseStrategyDto> {
    const selectedOrganization = useSelectedOrganizationAddress();
    const organizationAddress = orgAddressParam || selectedOrganization;

    return useQuery(
        [Queries.RELEASE_STRATEGY_FIND_ALL, query, page, pageSize, order, orderBy],
        async () => {
            const res = await releaseStrategyApi.findAll({
                page,
                pageSize,
                query,
                order,
                orderBy,
                organizationAddress,
            });
            return res.data;
        },
        { ...options },
    );
}
